import axios from 'utils/axios/axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash/fp';

const useAxios = ({ url, data, method = 'get', immediate = true } = {}) => {
	const { token, cancel } = useMemo(() => axios.CancelToken.source(), []);

	const [isLoading, setIsLoading] = useState(() => false);
	const [error, setError] = useState(() => false);
	const [responsedData, setResponsedData] = useState(() => null);

	const initialConfig = useMemo(() => {
		if (!url) return null;

		return {
			method,
			url,
			...(!isEmpty(data) && { data }),
		};
	}, [method, url, data]);

	const doRequest = useCallback(
		(additionalConfig = {}) => {
			if (!initialConfig) return setError(true);

			if (isEmpty(additionalConfig)) setIsLoading(true);

			setError(false);

			return axios({ ...initialConfig, ...additionalConfig, baseURL: '/bff', cancelToken: token })
				.then(({ data: { response } }) => {
					setResponsedData(response);
					setIsLoading(false);
				})
				.catch((e) => {
					if (axios.isCancel(e)) return;

					setError(e);
					setIsLoading(false);
				});
		},
		[initialConfig, token]
	);

	useEffect(() => {
		if (immediate) doRequest();

		return () => cancel('HOOK_UNMOUNTED');
	}, [immediate, doRequest, cancel]);

	return { isLoading, error, responsedData, doRequest };
};

export default useAxios;
